import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Report } from '../../report';
import { InvoiceAccountingReportService } from '../../services/invoice-accounting-report.service';

@Component({
  selector: 'app-invoice-accounting-report',
  templateUrl: './invoice-accounting-report.component.html',
  styleUrls: ['./invoice-accounting-report.component.scss']
})
export class InvoiceAccountingReportComponent implements OnInit {
  requestBody: Report = {};
  sellersArray: any[] = [];
  InvoiceAccountingData: any[] = [];
  totalNumberOfRecords: number = 0;
  bussinesId: number = 0;
  loading = false;
  tableColumns: string[] = [
    'id',
    'name',
    'sales',
    'fees',
    'vat',
    'advanced_repayment',
    'donation',
    'nbe_fees',
    'product_fees',
    'purchases_fees',
    'round_up_fees',
    'sms_fees',
    'taxNumber',
  ];

  displayTableColumns = {
    'id':'Business Id',
    'name':'Business Name',
    'sales':'Business Sales',
    'fees':'Business Fees',
    'vat':'Business Vat',
    'advanced_repayment': 'Advanced Repayment',
    'donation': 'Donation',
    'nbe_fees': 'NBE Fees',
    'product_fees': 'Product Fees',
    'purchases_fees': 'Purchases Fees',
    'sms_fees': 'SMS Fees',
	'round_up_fees': 'Roundup fees',
    'taxNumber':'Business Tax Number',
  };

  constructor(
    protected translate: TranslateService,
    public invoiceAccounting: InvoiceAccountingReportService) {}

  async ngOnInit() {
    this.invoiceAccounting.activateLoader();
    this.updateTable();
  }

  async displaySeller(event: any) {
    this.requestBody.selectedID = event;
    this.invoiceAccounting.setParams(this.requestBody);
    const report = await this.invoiceAccounting.make();
    this.InvoiceAccountingData = report.result;
    this.totalNumberOfRecords = report.totalNumberOfRows;
    console.log(this.InvoiceAccountingData)
  }

  async updateTable() {
    this.invoiceAccounting.activateLoader();
    this.invoiceAccounting.setParams(this.requestBody);
    const report = await this.invoiceAccounting.make();
    this.InvoiceAccountingData = report.result;
    this.totalNumberOfRecords = report.totalNumberOfRows;
  }

  async filter(event: any) {
    console.log('object is', event);
    if (event && Object.keys(event).length) {
      console.log('filter should not be null');
      this.requestBody.filterOptions = event;
    } else {
      console.log('filter should be null');
      this.requestBody.filterOptions = {};
    }
    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10
    };
    this.updateTable();
    this.invoiceAccounting.loader().subscribe(val => (this.loading = val));
  }

  async paginate(event: any) {
    this.requestBody.paginationOptions = {
      start: event.pageIndex * event.pageSize,
      limit: event.pageSize
    };
    this.updateTable();
    this.invoiceAccounting.loader().subscribe(val => (this.loading = val));
  }

  async searchChance(event: any) {
    if (event) {
      this.requestBody.searchOptions = {
        searchKey: event
      };
    } else {
      this.requestBody.searchOptions = undefined;
      this.invoiceAccounting.loader().subscribe(val => (this.loading = val));
    }
    await this.updateTable();
  }

  async sortChange(event: any) {
    if (event.direction === '') {
      this.requestBody.sortOptions = {};
    } else {
      this.requestBody.sortOptions = {
        [`${event.active}`]: event.direction
      };
    }
    await this.updateTable();
    this.invoiceAccounting.loader().subscribe(val => (this.loading = val));
  }
}
